import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../api/Agent';
import { handleError } from './user';
import mixpanelConstants from '../constants/mixpanel';

export const setComment = createAction('SET_COMMENT');
export const setTimesheetDetail = createAction('SET_TIMESHEET');
export const setShiftDetail = createAction('SET_SHIFT_DETAIL');
export const setCheckoutDetail = createAction('SET_CHECKOUT_DETAIL');
export const setLat = createAction('SET_LAT');
export const setLng = createAction('SET_LNG');
export const setCheckoutSuccess = createAction('SET_CEHCKOUT_SUCCESS');
export const setDuration = createAction('SET_DURATION');
export const setDateTime = createAction('SET_DATETIME');
export const setEndDateTime = createAction('SET_ENDDATETIME');
export const setShiftBreakTimes = createAction('SET_SHIFT_BREAK_TIMES');
export const setComments = createAction('SET_COMMENTS');
export const setMessage = createAction('SET_MESSAGE');
export const setRequestMessage = createAction('SET_REQUESTMESSAGE');
export const setRatingQuestions = createAction('SET_RATING_QUESTIONS');
export const setRatingDialogStatus = createAction('SET_RATING_DIALOG_STATUS');
export const setThankYouDialogStatus = createAction('SET_THANKYOU_DIALOG_STATUS');
export const setRatingQuestionIndex = createAction('SET_RATING_QUE_IDX');
export const setSubmitRatingResp = createAction('SET_RATING_RESP');
export const setRatingQueIdAnsId = createAction('SET_RATING_QUE_ANS_ID');
export const setcommentSuccess = createAction('SET_COMMENT_SUCCESS');

export const clearSubmitRatingResp = createAction('CLEAR_RATING_RESP');
export const clearRatingQueIdAnsId = createAction('CLEAR_RATING_QUE_ANS_ID');

const initialState = {
	breakTimes: [],
	checkoutDetails: {},
	checkoutSuccess: false,
	comment: '',
	commentSuccess: false,
	dateTime: '',
	duration: 30,
	endDateTime: '',
	lattd: '',
	lngtd: '',
	message: '',
	notesList: [],
	questionindex: 0,
	ratingQueAns: {},
	ratingResp: '',
	req_message: '',
	shiftDetails: {},
	showratingdailog: true,
	timesheet_detail: {}
};

export default handleActions(
	{
		CLEAR_RATING_QUE_ANS_ID: (state) => ({ ...state, ratingQueAns: initialState.ratingQueAns }),
		CLEAR_RATING_RESP: (state) => ({ ...state, ratingResp: initialState.ratingResp }),
		SET_CEHCKOUT_SUCCESS: (state, action) => ({ ...state, checkoutSuccess: action.payload }),
		SET_CHECKOUT_DETAIL: (state, action) => ({ ...state, checkoutDetails: action.payload }),
		SET_COMMENT: (state, action) => ({ ...state, comment: action.payload }),
		SET_COMMENT_SUCCESS: (state, action) => ({ ...state, commentSuccess: action.payload }),
		SET_COMMENTS: (state, action) => ({ ...state, notesList: action.payload }),
		SET_DATETIME: (state, action) => ({ ...state, dateTime: action.payload }),
		SET_DURATION: (state, action) => ({ ...state, duration: action.payload }),
		SET_ENDDATETIME: (state, action) => ({ ...state, endDateTime: action.payload }),

		SET_LAT: (state, action) => ({ ...state, lattd: action.payload }),
		SET_LNG: (state, action) => ({ ...state, lngtd: action.payload }),
		SET_MESSAGE: (state, action) => ({ ...state, message: action.payload }),
		SET_RATING_DIALOG_STATUS: (state, action) => ({ ...state, showratingdailog: action.payload }),
		SET_RATING_QUE_ANS_ID: (state, action) => ({ ...state, ratingQueAns: action.payload }),

		SET_RATING_QUE_IDX: (state, action) => ({ ...state, questionindex: action.payload }),
		SET_RATING_QUESTIONS: (state, action) => ({ ...state, ratingQuestions: action.payload }),
		SET_RATING_RESP: (state, action) => ({ ...state, ratingResp: action.payload }),
		SET_REQUESTMESSAGE: (state, action) => ({ ...state, req_message: action.payload }),
		SET_SHIFT_BREAK_TIMES: (state, action) => ({ ...state, breakTimes: action.payload }),
		SET_SHIFT_DETAIL: (state, action) => ({ ...state, shiftDetails: action.payload }),

		SET_THANKYOU_DIALOG_STATUS: (state, action) => ({ ...state, showthankyoudailog: action.payload }),
		SET_TIMESHEET: (state, action) => ({ ...state, timesheet_detail: action.payload })
	},
	initialState
);

export const shiftCheckout = (timesheet_id, lat, lng) => {
	return function (dispatch, getState) {
		const { timesheet_detail, message, shiftDetails } = getState().checkout;
		let checkoutComment = message;

		//Checkout api integration
		if (lat && lat != '' && lng && lng != '') {
			Agent.nurseCheckout(timesheet_id, checkoutComment, lat.toString(), lng.toString()).then((response) => {
				if (response.ok) {
					dispatch(setCheckoutSuccess(true));
					dispatch(setCheckoutDetail(response.data));
					dispatch(nurseShiftTimesheet(timesheet_detail.shift_id, lat, lng));
					dispatch(getTimesheetComment(timesheet_id));
					mixpanel.track(mixpanelConstants.CHECKOUT_COMPLETED, {
						checkinTime: timesheet_detail.checkin_time,
						checkoutComment: checkoutComment,
						organization: shiftDetails.organisation,
						organizationAddress: shiftDetails.address,
						shiftEndTime: shiftDetails.shift_end_datetime,
						shiftId: timesheet_detail.shift_id,
						timesheetId: timesheet_id
					});
				} else {
					alert(response.data);
				}
			});
		} else {
			alert(
				'Application could NOT fetch your geo location. Location has to be enabled to use the Check In Check Out feature. Please go to your browser settings and ENABLE Location.'
			);
		}
	};
};

export const shiftCheckIn = (shift_id, lat, lng) => {
	return function (dispatch, getState) {
		const { timesheet_detail, shiftDetails } = getState().checkout;

		if (lat && lat != '' && lng && lng != '') {
			Agent.nurseShiftCheckIn(parseInt(shift_id), lat.toString(), lng.toString()).then((response) => {
				if (response.ok) {
					dispatch(nurseShiftTimesheet(parseInt(shift_id), lat, lng));

					mixpanel.track(mixpanelConstants.CHECKIN_COMPLETED, {
						checkinTime: timesheet_detail.checkin_time,
						organization: shiftDetails.organisation,
						organizationAddress: shiftDetails.address,
						shiftEndTime: shiftDetails.shift_end_datetime,
						shiftId: shift_id,
						timesheetId: timesheet_detail.id
					});
				} else {
					alert(response.data);
				}
			});
		} else {
			alert(
				'Application could NOT fetch your geo location. Location has to be enabled to use the Check In Check Out feature. Please go to your browser settings and ENABLE Location.'
			);
		}
	};
};

export const nurseShiftTimesheet = (shift_id, lat, lng) => {
	return function (dispatch) {
		Agent.nurseShiftTimesheet(shift_id).then((response) => {
			if (response.ok) {
				dispatch(setTimesheetDetail(response.data));
				dispatch(fetchTimesheetComponents(response.data.id));
				dispatch(getTimesheetComment(response.data.id));
				if (response.data.id === undefined) {
					dispatch(shiftCheckIn(shift_id, lat, lng));
				}
			} else {
				dispatch(shiftCheckIn(shift_id, lat, lng));
			}
		});
	};
};

export const getShift = (id) => {
	return function (dispatch) {
		Agent.getShiftDetail(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftDetail(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Get breaktimes api call
export const fetchTimesheetComponents = (id) => {
	return function (dispatch) {
		Agent.getTimesheetComponents(id).then((response) => {
			if (response.ok) {
				dispatch(setShiftBreakTimes(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// get comment with timesheet id
export const getTimesheetComment = (timesheet_id) => {
	return function (dispatch) {
		Agent.getTimesheetNotes(timesheet_id).then((response) => {
			if (response.ok) {
				dispatch(setComments(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Add note api call
export const addComment = (timesheet_id, message_type) => {
	return function (dispatch, getState) {
		const { message, req_message, timesheet_detail } = getState().checkout;
		let note;
		if (message_type === 'mediation_req') {
			note = req_message;
		} else {
			note = message;
		}

		Agent.addComments(timesheet_id, note, message_type).then((response) => {
			if (response.ok) {
				dispatch(setcommentSuccess(true));
				dispatch(setMessage(''));
				dispatch(nurseShiftTimesheet(timesheet_detail.shift_id));

				mixpanel.track(mixpanelConstants.ADD_COMMENT, {
					comment: note,
					shiftId: timesheet_detail.shift_id,
					source: 'Nurse Checkout',
					timesheetId: timesheet_id
				});
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Get rating questions for organization
export const getOrgRatingQuestions = () => {
	return function (dispatch) {
		Agent.getRatingQuestions('organization').then((response) => {
			if (response.ok) {
				dispatch(setRatingQuestions(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Dismiss rating questions for organization
export const dismissOrgRatingQuestions = (org_id) => {
	return function (dispatch) {
		Agent.dismissOrgRatingQuestions(org_id).then((response) => {
			if (response.ok) {
				dispatch(setThankYouDialogStatus(true));

				mixpanel.track(mixpanelConstants.DISMISS_ORGANIZATION_RATING, { organisationId: org_id });
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Get rating questions for nurse
export const getNurseRatingQuestions = () => {
	return function (dispatch) {
		Agent.getRatingQuestions('nurse').then((response) => {
			if (response.ok) {
				dispatch(setRatingQuestions(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};
};

// Dismiss rating questions for nurse
export const dismissNurseRatingQuestions = (nurse_id, shift_id, user_id) => {
	return function (dispatch) {
		Agent.dismissNurseRatingQuestions(nurse_id, shift_id, user_id).then((response) => {
			if (response.ok) {
				dispatch(setThankYouDialogStatus(true));

				mixpanel.track(mixpanelConstants.DISMISS_NURSE_RATING, { nurseId: nurse_id, shiftId: shift_id });
			} else {
				dispatch(handleError(response));
			}

			dispatch(clearRatingQueIdAnsId());
		});
	};
};

// Submit rating questions for Nurse
export const submitNurseRatingQuestions = (que_idx, nurse_id, que_id, shift_id, user_id, answer_id, reason, notes) => {
	return function (dispatch, getState) {
		Agent.submitNurseRatingQuestions(nurse_id, que_id, shift_id, user_id, answer_id, reason, notes).then((response) => {
			if (response.ok) {
				dispatch(setRatingQuestionIndex(que_idx + 1));
				dispatch(setSubmitRatingResp({ que_idx: que_idx, status: response.ok }));

				trackRating(
					mixpanelConstants.SUBMIT_NURSE_RATING,
					getState().checkout.ratingQuestions,
					que_id,
					answer_id,
					shift_id,
					nurse_id
				);
			} else {
				dispatch(setSubmitRatingResp({ que_idx: que_idx, status: response.data }));
			}

			dispatch(clearRatingQueIdAnsId());
		});
	};
};

const trackRating = (trackingKey, ratingQuestions, que_id, answer_id, shift_id, id) => {
	let que = ratingQuestions && ratingQuestions.find((ques) => ques.id == que_id);
	let ans = que && que.que_options.find((option) => option.id == answer_id);
	mixpanel.track(trackingKey, {
		answer: ans && ans.option_text,
		answerId: answer_id,
		id: id,
		question: que && que.que_text,
		questionId: que_id,
		shiftId: shift_id
	});
};

export const resetNurseTimesheetDetail = () => {
	return function (dispatch) {
		dispatch(setMessage(''));
	};
};
